// removed by extract-text-webpack-plugin
module.exports = {"content":"bWbP-NELCrVxJNLrEMIgu","stepContent":"_3x2JCznJdAjv2fdkZWVJeQ","stepsBar":"_1r3HBiP4Xj80zFtRofNIf1","practiceNameHeader":"KEjplACrgPQPtKaZrw_6t","practiceName":"_3OKuVxlV5Rx8YUgLNVRUuF","cancelToggle":"_1HDly7fpMFTImnA_ln9z9s","cancelText":"_2Xz-1aJOMLn7EXu5e25OqT"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/index.css
// module id = 825
// module chunks = 0